var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineClipboardTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "vuesax/outline/clipboard-tick"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.811 16.953a.742.742 0 01-.53-.22l-1.5-1.5a.75.75 0 111.06-1.06l.97.97 3.47-3.472a.75.75 0 011.06 1.06l-4 4a.725.725 0 01-.53.222z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M14 6.75h-4c-.96 0-2.75 0-2.75-2.75S9.04 1.25 10 1.25h4c.96 0 2.75 0 2.75 2.75 0 .96 0 2.75-2.75 2.75zm-4-4c-.99 0-1.25 0-1.25 1.25S9.01 5.25 10 5.25h4c1.25 0 1.25-.26 1.25-1.25 0-1.25-.26-1.25-1.25-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M15 22.75H9c-5.62 0-6.75-2.581-6.75-6.75v-6c0-4.56 1.65-6.51 5.71-6.72a.75.75 0 01.79.71.742.742 0 01-.71.78C5.2 4.93 3.75 5.78 3.75 10v6c0 3.7.73 5.25 5.25 5.25h6c4.52 0 5.25-1.55 5.25-5.25v-6c0-4.22-1.45-5.07-4.29-5.23a.752.752 0 11.08-1.501c4.06.22 5.71 2.17 5.71 6.72v6c0 4.18-1.13 6.761-6.75 6.761z"
  }))));
}
export default SvgVuesaxOutlineClipboardTick;